import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/tdp.png"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="Yuva Galam Padayatra Success with Premagic AI Photos"
      description="How TDP’s Yuva Galam Padayatra used Premagic AI to boost political campaign engagement through instant photo sharing, social media reach, and Andhra Pradesh voter connections."
      metaImage={ThumbnailImage}
      keywords={[
        "Yuva Galam case study, TDP political campaign, Nara Lokesh padayatra, political photo sharing, campaign AI technology, Telugu political events, AP politics tech, political rally photos, campaign social media, TDP digital strategy, political event management, India political campaigns, Andhra Pradesh politics, political engagement tools, campaign photo distribution",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Yuva Galam Padayatra", url: "/case-study/yuva-galam/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Yuva Galam Padayatra Success with Premagic AI Photos",
            "description": "How TDP’s Yuva Galam Padayatra used Premagic AI to boost political campaign engagement through instant photo sharing, social media reach, and Andhra Pradesh voter connections.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2023-01-15",
            "dateModified": "2024-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.TDP} />
    </Layout>
  )
}

export default Index
